export default __webpack_public_path__ + "static/media/invisage-hero.0fb2a927.png";